var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('EvaluationActionText',{staticClass:"mr-3"}),(_vm.canFavorite)?_c('Favorite',{staticClass:"flex-1 sm:flex-initial"}):_vm._e(),(_vm.canSkip)?_c('Skip',{staticClass:"flex-1 sm:flex-initial",class:{ 'ml-3': _vm.canFavorite }}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }